/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PopupsPopupIdEditRouteImport } from './routes/popups/$popupId/edit'

const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PopupsPopupIdEditRoute = PopupsPopupIdEditRouteImport.update({
  id: '/popups/$popupId/edit',
  path: '/popups/$popupId/edit',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/usage': typeof UsageRoute
  '/popups/$popupId/edit': typeof PopupsPopupIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/usage': typeof UsageRoute
  '/popups/$popupId/edit': typeof PopupsPopupIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/usage': typeof UsageRoute
  '/popups/$popupId/edit': typeof PopupsPopupIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/usage' | '/popups/$popupId/edit'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/usage' | '/popups/$popupId/edit'
  id: '__root__' | '/' | '/usage' | '/popups/$popupId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UsageRoute: typeof UsageRoute
  PopupsPopupIdEditRoute: typeof PopupsPopupIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/popups/$popupId/edit': {
      id: '/popups/$popupId/edit'
      path: '/popups/$popupId/edit'
      fullPath: '/popups/$popupId/edit'
      preLoaderRoute: typeof PopupsPopupIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UsageRoute: UsageRoute,
  PopupsPopupIdEditRoute: PopupsPopupIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
